module.exports = __webpack_public_path__ + "static/img/71-1.34bbaaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/71-1.jpg
// module id = Rd/Z
// module chunks = 0